import jquery__WEBPACK from "jquery";
import select2 from "select2";

//__webpack_require__.r(__webpack_exports__);
///* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
///* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
///* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
///* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
///* harmony import */ var select2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! select2 */ "./node_modules/select2/dist/js/select2.js");
///* harmony import */ var select2__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(select2__WEBPACK_IMPORTED_MODULE_2__);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

//__webpack_require__(/*! select2/src/scss/core.scss */ "./node_modules/select2/src/scss/core.scss");
/* harmony default export */ __webpack_exports__["default"] = ((function () {
  var $html = jquery__WEBPACK("html");
  var checkForMembership = jquery__WEBPACK("body").attr("id");
  var defaultOpenFirstDropDown = true;
  var StyleQuiz = {
    currentStep: 0,
    totalSteps: {
      m: jquery__WEBPACK('.quiz--standard .quiz__step[data-for-step*="m"]').length + 1,
      f: jquery__WEBPACK('.quiz--standard .quiz__step[data-for-step*="f"]').length + 1
    },
    hasSelect2Active: false,
    init: function init() {
      this.choseLifeStyle = [];
      this.$container = jquery__WEBPACK(".quiz--standard");
      this.$form = jquery__WEBPACK("form", this.$container);
      this.$drawer = jquery__WEBPACK(".quiz__drawer", this.$container);
      this.$prevBtn = jquery__WEBPACK(".js-prevstep", this.$container);
      this.$nextBtn = jquery__WEBPACK(".js-nextstep", this.$container);
      if (checkForMembership == 'fairway-membership' || checkForMembership == 'executive-membership' || checkForMembership == 'magnolia-box') {
        this.goToStep(2);
      } else {
        this.goToStep(1);
      }
      this.loadSessionData();
      this.onFormChanged();
      this.initEventHandlers();
      this.allowUserToUncheckRadioInputs();
      this.initOrDestroySelect2();
      if (window.location.search.indexOf("showquiz=true") > -1) {
        this.show();
      }
    },
    allowUserToUncheckRadioInputs: function allowUserToUncheckRadioInputs() {
      var _this = this;
      var self = this;
      var choseLifeStyle = [];
      jquery__WEBPACK('[type="radio"] + label', this.$container).click(function () {
        var target = jquery__WEBPACK(this).attr("for");
        var styleValue = jquery__WEBPACK(this).attr("id");
        var parent_element = jquery__WEBPACK(this).closest(".quiz__step.is-active").attr('data-for-step');
        if (parent_element.includes('2')) {
          if (choseLifeStyle.length > 0) {
            choseLifeStyle[0] = styleValue;
          } else {
            choseLifeStyle.push(styleValue);
          }
        } else if (parent_element.includes('3')) {
          if (choseLifeStyle.length > 1) {
            choseLifeStyle[1] = styleValue;
          } else {
            choseLifeStyle.push(styleValue);
          }
        } else if (parent_element.includes('4')) {
          if (choseLifeStyle.length > 2) {
            choseLifeStyle[2] = styleValue;
          } else {
            choseLifeStyle.push(styleValue);
          }
        }
        self.choseLifeStyle = _toConsumableArray(choseLifeStyle);
        if (parent_element.includes('5')) {
          var styleSortedArray = _toConsumableArray(choseLifeStyle).sort();
          var choseLifeStyleDuplicate = [];
          for (var i = 0; i < styleSortedArray.length - 1; i++) {
            if (styleSortedArray[i + 1] == styleSortedArray[i]) {
              choseLifeStyleDuplicate.push(styleSortedArray[i]);
            }
          }
        }
        var $radio = jquery__WEBPACK("#".concat(target));
        if ($radio[0].checked == true) {
          setTimeout(function () {
            $radio[0].checked = false;
            self.onFormChanged();
          }, 0);
        } else {
          if (parent_element.includes('7')) {
            if (checkForMembership == 'fairway-membership' || checkForMembership == 'executive-membership' || checkForMembership == 'magnolia-box') {
              $radio[0].checked = true;
            }
          }
        }
      });
      jquery__WEBPACK(document).on('click', '.quiz__drawer-content .retake_quiz_text .retake_quiz_link', function (e) {
        choseLifeStyle = [];
        _this.goToStep(2);
      });
    },
    initEventHandlers: function initEventHandlers() {
      var self = this;
      jquery__WEBPACK(window).resize(this.onResized.bind(this));
      this.$form.on("change", this.onFormChanged.bind(this));
      jquery__WEBPACK('a[href*="pages/get-styled"]').click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        if ($html.hasClass("quiz-open") === false) {
          if (window.innerWidth <= 749) {
            let topContainer = 0;
            if (document.querySelector('.shopify-section-group-header-group')) {
              topContainer += document.querySelector('.shopify-section-group-header-group').offsetHeight;
            }
            if (document.querySelector('.section-header.shopify-section-group-header-group')) {
              if (document.querySelector('.section-header.shopify-section-group-header-group.scrolled-past-header')) {
                topContainer = document.querySelector('.section-header.shopify-section-group-header-group').offsetHeight;
              } else {
                topContainer += document.querySelector('.section-header.shopify-section-group-header-group').offsetHeight;
              }
            }
            if (topContainer !== 0) {
              document.querySelector('.style-quiz-container.quiz--standard').style.top = topContainer + 'px';
            } else {
              document.querySelector('.style-quiz-container.quiz--standard').style.top = '';
            }
          } else {
            document.querySelector('.style-quiz-container.quiz--standard').style.top = '';
          }
          $html.removeClass("nav-open");
          self.show();
        } else {
          self.hide();
          self.saveSessionData();
        };
      });
      jquery__WEBPACK(".style-quiz-bg").click(function () {
        self.hide();
        self.saveSessionData();
      });

      //Quiz Male or female button click next button direct click

      jquery__WEBPACK(".js-nextstep", this.$container).click(function (e) {
        e.preventDefault();
        var gender = '';
        if (checkForMembership == 'fairway-membership' || checkForMembership == 'executive-membership') {
          gender = "m";
        } else if (checkForMembership == 'magnolia-box') {
          gender = "f";
        } else {
          gender = jquery__WEBPACK("#gender_male:checked", this.$container).length ? "m" : "f";
        }
        var stepInt = parseInt(self.currentStep);
        if (stepInt > 1 && stepInt == self.totalSteps[gender]) {
          self.addToBag();
          self.saveSessionData();
        } else {
          self.nextStep();
        }
      });
      jquery__WEBPACK(".js-prevstep", this.$container).click(function (e) {
        e.preventDefault();
        self.prevStep();
      });
      jquery__WEBPACK(".quiz__select", this.$form).click(function () {
        if (self.hasSelect2Active) {
          jquery__WEBPACK("select", this).select2("open");
        }
      });
      jquery__WEBPACK("select", this.$form).change(function () {
        var currentParent = jquery__WEBPACK(this).parents(".quiz__select");
        var nextEle = currentParent.nextAll();
        var prevEle = currentParent.prevAll();
        var flag = true;
        if (nextEle.length > 0) {
          nextEle.map(function (i, item) {
            var classes = jquery__WEBPACK(item).attr("class");
            if (!classes.includes('is-complete') && flag) {
              flag = false;
              jquery__WEBPACK('select', item).select2("open");
            }
          });
        }
        if (flag && prevEle.length > 0) {
          prevEle.map(function (i, item) {
            var classes = jquery__WEBPACK(item).attr("class");
            if (!classes.includes('is-complete') && flag) {
              flag = false;
              jquery__WEBPACK('select', item).select2("open");
            }
          });
        }
        if (flag) {
          currentParent.addClass('is-complete');
          var currentStep = jquery__WEBPACK(".quiz__modal.quiz--standard", this.$container).attr("data-current-step");
          self.goToStep(currentStep);
        }
      });
      jquery__WEBPACK("select", this.$form).on("select2:open", function (e) {
        jquery__WEBPACK(".select2-dropdown").hide().fadeIn(200);
      });
    },
    selectDefaultQuizOption: function selectDefaultQuizOption(parentEle) {
      var styleSortedArray = _toConsumableArray(this.choseLifeStyle).sort();
      var choseLifeStyleDuplicate = [];
      for (var i = 0; i < styleSortedArray.length - 1; i++) {
        if (styleSortedArray[i + 1] == styleSortedArray[i]) {
          choseLifeStyleDuplicate.push(styleSortedArray[i]);
        }
      }
      parentEle.querySelectorAll('input').forEach(function (ele) {
        if (choseLifeStyleDuplicate.length > 0) {
          if (ele.value === choseLifeStyleDuplicate[0]) {
            ele.checked = true;
            ele.labels[0].classList.add('active-style');
            ele.labels[0].classList.remove('hide');
          } else {
            ele.labels[0].classList.remove('active-style');
            ele.labels[0].classList.add('hide');
          }
        } else {
          if (ele.value === 'All Styles') {
            ele.checked = true;
            ele.labels[0].classList.add('active-style');
            ele.labels[0].classList.remove('hide');
          } else {
            ele.labels[0].classList.remove('active-style');
            ele.labels[0].classList.add('hide');
          }
        }
      });
    },
    selectDefaultMembershipOption: function selectDefaultMembershipOption(parentEle) {
      var currentMembership = '';
      if (checkForMembership == 'fairway-membership') {
        currentMembership = 'The Fairway Package';
      } else if (checkForMembership == 'executive-membership') {
        currentMembership = 'The Executive Package';
      } else if (checkForMembership == 'magnolia-box') {
        currentMembership = 'Magnolia Box';
      }
      parentEle.querySelectorAll('input').forEach(function (ele) {
        if (ele.value === currentMembership) {
          ele.checked = true;
        }
      });
    },
    onFormChanged: function onFormChanged() {
      this.saveSessionData();
      this.updateSelectInputStatus();
      this.updateNextButtonStatus();
      this.updateDrawer();
    },
    onResized: function onResized() {
      if ($html.hasClass("quiz-open")) {
        this.updateDrawer();
        this.goToStep(this.currentStep);
        this.initOrDestroySelect2();
      }
    },
    sendAnalytics: function sendAnalytics(action) {
      try {
        gtag("event", "StyleQuiz", {
          eventCategory: "StyleQuiz",
          eventAction: action
        });
        /*fbq('track', 'ViewContent', {
          content_name: action,
          content_category: 'StyleQuiz'
        });*/
      } catch (e) {
        console.log("Error logging StyleQuiz event", e);
      }
    },
    sendStepAnalytics: function sendStepAnalytics() {
      if (!$html.hasClass("quiz-open")) {
        return;
      }
      if (checkForMembership == 'fairway-membership' || checkForMembership == 'executive-membership') {
        var stepNames = {
          "2m": "Step 1 (male): MStepStyle",
          "3m": "Step 2 (male): MStepStyle",
          "4m": "Step 3 (male): MStepStyle",
          "5m": "Step 4 (male): MStepStyle",
          "6m": "Step 5 (male): MStepSizes",
          "7m": "Step 6 (male): MStepBoxes"
        };
      } else if (checkForMembership == 'magnolia-box') {
        var stepNames = {
          "2f": "Step 1 (female): FStepStyle",
          "3f": "Step 2 (female): FStepStyle",
          "4f": "Step 3 (female): FStepStyle",
          "5f": "Step 4 (female): FStepStyle",
          "6f": "Step 5 (female): FStepSizes",
          "7f": "Step 6 (female): FStepBoxes"
        };
      } else {
        var stepNames = {
          "1": "Step 1: StepGender",
          "2m": "Step 2 (male): MStepStyle",
          "3m": "Step 3 (male): MStepStyle",
          "4m": "Step 4 (male): MStepStyle",
          "5m": "Step 5 (male): MStepStyle",
          "6m": "Step 6 (male): MStepSizes",
          "7m": "Step 7 (male): MStepBoxes",
          "2f": "Step 2 (female): FStepStyle",
          "3f": "Step 3 (female): FStepStyle",
          "4f": "Step 4 (female): FStepStyle",
          "5f": "Step 5 (female): FStepStyle",
          "6f": "Step 6 (female): FStepSizes",
          "7f": "Step 7 (female): FStepBoxes"
        };
      }
      this.sendAnalytics(stepNames[this.currentStep]);
    },
    show: function show() {
      $html.addClass("quiz-open");
      this.updateDrawer();
      this.sendAnalytics("Opened");
      this.sendStepAnalytics();
    },
    hide: function hide() {
      $html.removeClass("quiz-open");
      this.sendAnalytics("Closed");
    },
    initOrDestroySelect2: function initOrDestroySelect2() {
      var isMobile = jquery__WEBPACK(window).width() < 768;
      var $selects = jquery__WEBPACK("select", this.$form);
      if (this.hasSelect2Active == false) {
        $selects.select2({
          minimumResultsForSearch: Infinity,
          width: "100%"
        });
        $selects.addClass("hide");
        this.hasSelect2Active = true;
      }
    },
    refreshSelect2: function refreshSelect2() {
      var $selects = jquery__WEBPACK("select", this.$form);
      if (!this.hasSelect2Active) {
        return;
      }
      $selects.select2("destroy");
      this.hasSelect2Active = false;
      this.initOrDestroySelect2();
    },
    updateSelectInputStatus: function updateSelectInputStatus() {
      var $selects = jquery__WEBPACK("select", this.$form);
      jquery__WEBPACK.each($selects, function () {
        var $select = jquery__WEBPACK(this);
        var $label = $select.parents(".quiz__select");
        if (!$select.val()) {
          $label.removeClass("is-complete");
        } else {
          $label.addClass("is-complete");
        }
      });
    },
    updateNextButtonStatus: function updateNextButtonStatus(isPrev) {
      var _this2 = this;
      var $activeStep = jquery__WEBPACK(".quiz__step.is-active", this.$container);
      var $inputs = jquery__WEBPACK("input, select", $activeStep);
      var getStep = $activeStep.attr('data-for-step');
      getStep = parseInt(getStep) + 1;
      var stepIsComplete = true;
      jquery__WEBPACK.each($inputs, function () {
        var $input = jquery__WEBPACK(this);
        if ($input.is('[type="radio"]')) {
          var radioGroup = $input.attr("name");
          if (jquery__WEBPACK("[name=\"".concat(radioGroup, "\"]:checked"), $activeStep).length == 0) {
            stepIsComplete = false;
          }
        } else if ($input.is("select")) {
          if (!$input.val()) {
            stepIsComplete = false;
          }
        }
      });
      if (stepIsComplete) {
        this.$nextBtn.addClass("pulse").prop("disabled", false);
        if (!isPrev) {
          if (getStep <= 6 || getStep < 7) {
            this.goToStep(getStep);
          }
          var slideElement = document.querySelector('.quiz__step.step-style.is-active');
          if (slideElement && (slideElement.getAttribute('data-for-step') === '5m' || slideElement.getAttribute('data-for-step') === '5f')) {
            /* Select default quiz option for Step 5 */
            this.$nextBtn.addClass("pulse").prop("disabled", false);
            this.selectDefaultQuizOption(slideElement);
          }
          var MemberShipStep = document.querySelector('.quiz__step.step-boxes.is-active');
          if (MemberShipStep && MemberShipStep.getAttribute('data-for-step') === '7m') {
            /* Select default membership option for Step 7 */
            if (checkForMembership == 'fairway-membership' || checkForMembership == 'executive-membership' || checkForMembership == 'magnolia-box') {
              this.$nextBtn.addClass("pulse").prop("disabled", false);
              this.selectDefaultMembershipOption(MemberShipStep);
            }
          }
        }
      } else {
        this.$nextBtn.removeClass("pulse").prop("disabled", true);
        var _slideElement = document.querySelector('.quiz__step.step-sizes.is-active');
        if (defaultOpenFirstDropDown) {
          if (_slideElement && (_slideElement.getAttribute('data-for-step') === '6m' || _slideElement.getAttribute('data-for-step') === '6f')) {
            /* Select default quiz option for Step 5 */
            var firstSelect = jquery__WEBPACK('.quiz__select:first', _slideElement);
            var currentSelect = jquery__WEBPACK('select', firstSelect);
            if (!firstSelect.attr("class").includes('is-complete')) {
              setTimeout(function () {
                currentSelect.select2('open');
              }, 1000);
              defaultOpenFirstDropDown = false;
            }
          }
        }
        var _MemberShipStep = document.querySelector('.quiz__step.step-boxes.is-active');
        if (_MemberShipStep && (_MemberShipStep.getAttribute('data-for-step') === '7m' || _MemberShipStep.getAttribute('data-for-step') === '7f')) {
          /* Select default membership option for Step 7 */
          if (checkForMembership == 'fairway-membership' || checkForMembership == 'executive-membership' || checkForMembership == 'magnolia-box') {
            this.$nextBtn.addClass("pulse").prop("disabled", false);
            this.selectDefaultMembershipOption(_MemberShipStep);
          } else {
            if (_MemberShipStep.getAttribute('data-for-step') === '7f') {
              _MemberShipStep.querySelectorAll('input').forEach(function (ele) {
                if (ele.value === 'Magnolia Box') {
                  ele.checked = true;
                  _this2.$nextBtn.addClass("pulse").prop("disabled", false);
                }
              });
            }
          }
        }
      }
    },
    updateDrawer: function updateDrawer() {
      // check if this step has drawer content and slide it open/closed
      var $stepDrawerContent = jquery__WEBPACK(".quiz__drawer-content[data-for-step*=\"".concat(this.currentStep, "\"]"), this.$container);
      var $step = jquery__WEBPACK(".quiz__step[data-for-step*=\"".concat(this.currentStep, "\"]"), this.$container);
      jquery__WEBPACK(".quiz__drawer-content", this.$container).removeClass("is-showing");
      if ($stepDrawerContent.length > 0 &&
      // this step has a drawer
      jquery__WEBPACK("input:checked", $step).length > 0) {
        // has an option in this step been selected
        $stepDrawerContent.addClass("is-showing");
        this.$drawer.addClass("is-open").css("height", $stepDrawerContent.outerHeight());
      } else {
        // no drawer for this step, slide it closed
        this.$drawer.removeClass("is-open").css("height", "");
      }
      this.updateDrawerValues();
    },
    updateDrawerValues: function updateDrawerValues() {
      var $datas = jquery__WEBPACK("[data-for-value]", this.$drawer).removeClass("is-active");
      var $activeStep = jquery__WEBPACK(".quiz__step.is-active", this.$container);
      var $selectedRadio = jquery__WEBPACK("input:checked", $activeStep);
      var radioValue = $selectedRadio.val();
      jquery__WEBPACK("[data-for-value*=\"".concat(radioValue, "\"]"), this.$drawer).addClass("is-active");
    },
    adjustOptionAvailability: function adjustOptionAvailability() {
      // Custom logic per selected box:
      // The Tour Experience box does not offer the following sizes:
      // Shirt size is XXX-Large
      // Pant waist is 42 or larger

      var userSelectedTourBox = jquery__WEBPACK("#box_tour", this.$container).is(":checked");
      var $shirtSize = jquery__WEBPACK("#shirt_size", this.$container);
      var $pantSize = jquery__WEBPACK("#pant_size", this.$container);
      if (userSelectedTourBox) {
        jquery__WEBPACK('[value*="XXX"]', $shirtSize).prop("selected", false).attr("hidden", "hidden").attr("disabled", "disabled");
        jquery__WEBPACK('[value*="42"], [value*="44"]', $pantSize).prop("selected", false).attr("hidden", "hidden").attr("disabled", "disabled");
      } else {
        jquery__WEBPACK("option:not(:first-child)", $shirtSize).removeAttr("disabled hidden");
        jquery__WEBPACK("option:not(:first-child)", $pantSize).removeAttr("disabled hidden");
      }
      this.refreshSelect2();
    },
    goToStep: function goToStep(step, isPrev) {
      var stepInt = parseInt(step);
      var gender = "";
      if (stepInt > 1) {
        if (checkForMembership == 'fairway-membership' || checkForMembership == 'executive-membership') {
          gender = "m";
        } else if (checkForMembership == 'magnolia-box') {
          gender = "f";
        } else {
          gender = jquery__WEBPACK("#gender_male:checked", this.$container).length ? "m" : "f";
        }
        step = stepInt + gender;
        jquery__WEBPACK(".total-step-text", this.$container).text("0" + this.totalSteps[gender]);
      }
      jquery__WEBPACK("[data-for-step]", this.$container).removeClass("is-active");
      jquery__WEBPACK("[data-for-step*=\"".concat(step, "\"]"), this.$container).addClass("is-active");
      jquery__WEBPACK(".current-step-text", this.$container).text("0" + stepInt);
      this.currentStep = step;
      this.$form.attr("data-current-step", step);
      if (checkForMembership == 'fairway-membership' || checkForMembership == 'executive-membership' || checkForMembership == 'magnolia-box') {
        if (step == '2m' || step == '2f') {
          this.$prevBtn.attr("disabled", "disabled");
        } else {
          this.$prevBtn.removeAttr("disabled");
        }
      } else {
        if (step <= 1) {
          this.$prevBtn.attr("disabled", "disabled");
        } else {
          this.$prevBtn.removeAttr("disabled");
        }
      }
      if (step == this.totalSteps[gender]) {
        this.$nextBtn.attr("disabled", "disabled");
      } else {
        this.$nextBtn.removeAttr("disabled");
      }
      var slideElement = document.querySelector('.quiz__step.step-sizes.is-active');
      if (slideElement && (slideElement.getAttribute('data-for-step') === '6m' || slideElement.getAttribute('data-for-step') === '6f')) {
        defaultOpenFirstDropDown = true;
      }
      if ($html.hasClass("quiz-open")) {
        this.updateDrawer();
      }
      this.adjustOptionAvailability();
      this.updateNextButtonStatus(isPrev);
      this.sendStepAnalytics();
    },
    /*shouldSkipPersonaStep() {
      const gender = $("#gender_male:checked", this.$container).length
        ? "m"
        : "f";
      const selectedMaleBox = $(
        '[name="package"]:checked',
        this.$container
      ).val();
            // On Male side, Tour and PGA boxes don't have Persona steps
      if (gender == "m") {
        if (
          selectedMaleBox == "Tour Experience" ||
          selectedMaleBox == "PGA of America"
        ) {
          return true;
        }
      }
            return false;
    },*/
    nextStep: function nextStep() {
      var stepInt = parseInt(this.currentStep);
      var gender = '';
      if (checkForMembership == 'fairway-membership' || checkForMembership == 'executive-membership') {
        gender = "m";
      } else if (checkForMembership == 'magnolia-box') {
        gender = "f";
      } else {
        gender = jquery__WEBPACK("#gender_male:checked", this.$container).length ? "m" : "f";
      }
      if (stepInt < this.totalSteps[gender]) {
        // Skip and unselect Persona selection if necessary
        /*if (this.shouldSkipPersonaStep() && stepInt == 2) {
          $('[name="style"]:checked', this.$container).prop("checked", false);
          stepInt += 1;
        }*/
        this.goToStep(stepInt + 1 + gender);
      }
    },
    prevStep: function prevStep() {
      var stepInt = parseInt(this.currentStep);
      var gender = jquery__WEBPACK("#gender_male:checked", this.$container).length ? "m" : "f";
      if (stepInt == 2) {
        this.goToStep(1, true);
      } else if (stepInt > 2) {
        /*if (this.shouldSkipPersonaStep() && stepInt == 4) {
          stepInt -= 1;
        }*/
        this.goToStep(stepInt - 1 + gender, true);
      }
    },
    saveSessionData: function saveSessionData() {
      var serialized = this.$form.serializeArray();
      sessionStorage.setItem("stylequizdata", JSON.stringify(serialized));
    },
    clearSessionData: function clearSessionData() {
      sessionStorage.removeItem("stylequizdata");
    },
    loadSessionData: function loadSessionData() {
      var savedData = JSON.parse(sessionStorage.getItem("stylequizdata"));
      jquery__WEBPACK.each(savedData, function () {
        var name = this.name,
          value = this.value;
        jquery__WEBPACK("[name=\"".concat(name, "\"]:not([type=\"radio\"]):not([type=\"checkbox\"])"), this.$container).val(value);
        jquery__WEBPACK("[name=\"".concat(name, "\"][value=\"").concat(value, "\"]"), this.$container).prop("checked", true);
      });
    },
    addToBag: function addToBag() {
      var userOptions = this.$form.serializeArray();
      var userGender = '';
      if (checkForMembership == 'fairway-membership' || checkForMembership == 'executive-membership') {
        userGender = "m";
      } else if (checkForMembership == 'magnolia-box') {
        userGender = "f";
      } else {
        userGender = jquery__WEBPACK("#gender_male:checked", this.$container).length ? "m" : "f";
      }

      // Set defaults
      var postdata = {
        quantity: 1,
        "properties[shipping_interval_frequency]": "1",
        "properties[shipping_interval_unit_type]": "Months"
      };

      // Supply gender as a property
      if (userGender == "f") {
        postdata["properties[sp4_gender]"] = "Female";
      } else {
        postdata["properties[sp4_gender]"] = "Male";
      }

      // Add all user's selections into the postdata
      jquery__WEBPACK.each(userOptions, function () {
        var name = this.name,
          value = this.value;
        if (userGender == "m" && name.indexOf("female_") == -1) {
          postdata["properties[sp4_".concat(name, "]")] = value;
        } else if (userGender == "f" && name.indexOf("female_") > -1) {
          name = name.replace("female_", "");
          postdata["properties[sp4_".concat(name, "]")] = value;
        }
      });


      var IDs = {
        "The Fairway Package": {
          Athletic: {
            variant: "1292559264",
            subscription: "1522",
            selling_plan: 1190821978
          },
          "Loud & Wild": {
            variant: "1253803928",
            subscription: "1523",
            selling_plan: 1190658138
          },
          Traditional: {
            variant: "1253804956",
            subscription: "1355",
            selling_plan: 1190428762
          },
          "All Styles": {
            variant: "1292569496",
            subscription: "1524",
            selling_plan: 1190592602
          }
        },
        "The Executive Package": {
          Athletic: {
            variant: "30648201801",
            subscription: "41251",
            selling_plan: 1190395994
          },
          "Loud & Wild": {
            variant: "30648239945",
            subscription: "41254",
            selling_plan: 1189937242
          },
          Traditional: {
            variant: "30649335369",
            subscription: "41248",
            selling_plan: 1189904474
          },
          "All Styles": {
            variant: "30647847753",
            subscription: "41257",
            selling_plan: 1190133850
          }
        },
        "Tour Experience": {
          variant: "2373448204297", // not found
          subscription: "114300",
          selling_plan: 1190395994 // not found
        },
        "Magnolia Box": {
          //variant: "16936738685018",
          //subscription: "204080",
          Athletic: {
            variant: "39365133860954", // product duplicate of recharge
            subscription: "300662",
            variantOriginal: "39365075075162", // product original
            selling_plan: 1190625370 // product original
          },

          Traditional: {
            variant: "39365133369434", // product duplicate of recharge
            subscription: "300661",
            variantOriginal: "39365075402842", // product original
            selling_plan: 1189838938 // don't has selling plan
          }
        },

        "PGA of America": {
          variant: "31083252678746", // not found
          // Male product variant ID
          subscription: "223172" // Male ReCharge ruleset ID
        }
      };

      var style = postdata["properties[sp4_style]"];
      var box = postdata["properties[sp4_package]"];
      // console.table( 'style', style );
      // console.table( 'box', box );

      // Set the Product Variant ID and ReCharge Ruleset ID
      postdata["id"] = IDs[box].variant;
      postdata["properties[subscription_id]"] = IDs[box].subscription;
      if (IDs[box].selling_plan !== undefined) {
        postdata["selling_plan"] = IDs[box].selling_plan;

        if (IDs[box].variantOriginal !== undefined) {
          postdata["id"] = IDs[box].variantOriginal;
        }

        delete postdata["properties[subscription_id]"];
        delete postdata["properties[shipping_interval_frequency]"];
        delete postdata["properties[shipping_interval_unit_type]"];
      }

      // Fairway & Executive have SKUs for each "Persona"
      if (box == "The Fairway Package" || box == "The Executive Package" || box == "Magnolia Box") {
        var _IDs$box$style;
        postdata["id"] = IDs[box][style].variant;
        postdata["properties[subscription_id]"] = IDs[box][style].subscription;

        if ((_IDs$box$style = IDs[box][style]) !== null && _IDs$box$style !== void 0 && _IDs$box$style.selling_plan) {
          postdata["selling_plan"] = IDs[box][style].selling_plan;

          if (_IDs$box$style.variantOriginal !== undefined) {
            postdata["id"] = _IDs$box$style.variantOriginal;
          }

          delete postdata["properties[subscription_id]"];
          delete postdata["properties[shipping_interval_frequency]"];
          delete postdata["properties[shipping_interval_unit_type]"];
        }
      }

      // Tour & PGA have no "Persona", so set it to 'None'
      if (box == "Tour Experience" || box == "PGA of America") {
        postdata["properties[sp4_style]"] = "None";
      }

      // PGA of America has different SKUs for Male/Female
      if (userGender == "f" && box == "PGA of America") {
        postdata["id"] = "31083252678746"; // TREVOR: Female product variant ID
        postdata["properties[subscription_id]"] = "223172"; // TREVOR: Female ReCharge ruleset ID
        delete postdata["selling_plan"];
      }

      // Magnolia and PGA of America ship every 2 months
      /*if (box == "Magnolia Box" || box == "PGA of America") {
        postdata["properties[shipping_interval_frequency]"] = "2";
      }*/

      //console.table( postdata );

      const properties = {};
      for (const key in postdata) {
          if (key.startsWith('properties[')) {
              const propName = key.slice(11, -1);
              properties[propName] = postdata[key];
          }
      }
      const body = {
        items: [
          {
            id: postdata["id"],
            quantity: 1,
            properties: properties,
            selling_plan: postdata["selling_plan"]
          }
        ]
      };
      //console.log('properties', properties);
      this.hide();
      liquidAjaxCart.add(body, {});

      this.sendAnalytics("AddToCart");
    }
  };
  StyleQuiz.init();
  window.StyleQuiz = StyleQuiz;
})());

//# sourceURL=webpack:///./javascript/core/style-quiz.js?
